module.exports = __webpack_public_path__ + "assets/img/gift-6-23f1ab24.png";